// Imports
import InfiniteScroll from 'infinite-scroll';
import LazyLoad from 'vanilla-lazyload';

// Project imports
import Appear from '@js/modules/Appear';

const attr = 'data-endless-scroll';

/**
 * Usage
 *
 * <div data-endless-scroll="projects/p{{#}}">
 *     <div class="item">...</div>
 *     <div class="item">...</div>
 * </div>
 *
 * Set to a string with {{#}} for the incremental page number.
 * path: 'projects/p{{#}}'
 * replace {{#}} with page number => projects/p2, projects/p3, projects/p4
 */

class EndlessScroll {
    constructor() {}
    init() {
        const endlessScrollEl = document.querySelector(`[${attr}]`);

        if (endlessScrollEl) {
            const endlessScrollPath = endlessScrollEl.getAttribute(attr);

            let infScroll = new InfiniteScroll(endlessScrollEl, {
                path: '.endless-scroll-next',
                append: '.item',
                checkLastPage: '.endless-scroll-next',
                history: false,
            });

            infScroll.on('request', (path, fetchPromise) => {
                console.log('Request: ', path);
            });
            infScroll.on('append', (body, path, items, response) => {
                Appear.start();

                new LazyLoad({
                    threshold: 400
                });
            });
        }
    }
}

export default new EndlessScroll();
